<template lang="html">
  <div class="info">
    <template v-if="team !== null">
      <h3>{{ $t('plan') }}</h3>
      <ul>
        <li>
          <strong>{{ $t('plan_name') }}: </strong>
          <span>{{ team.plan.name }}</span>
        </li>
        <li>
          <strong>{{ $t('plan_remaining') }}: </strong>
          <span>{{ convertSeconds(team.plan.remaining) }}</span>
        </li>
        <li>
          <strong>{{ $t('mention_quota') }}: </strong>
          <span>{{ team.plan.limitations.mention_quota.cap }}</span>
        </li>
        <li>
          <strong>{{ $t('keyword_quota') }}: </strong>
          <span>{{ team.plan.limitations.keyword_quota.cap }}</span>
        </li>

      </ul>
      <h3>{{ $t('members') }}</h3>
      <members
        :user="team.owner.id.numberStr" />
      <h3>{{ $t('inboxes') }}</h3>
      <inboxes
        :team="$route.params.id"
        :path="`${domainsPath}/users/${team.owner.id.numberStr}/teams/${$route.params.id}/inboxes`"/>
    </template>
  </div>
</template>

<script>
import Inboxes from '@/components/customers/Inboxes'
import Members from '@/components/team/Members'
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      team: null
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath'
    ])
  },
  components: {
    Inboxes,
    Members
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    setData (res) {
      this.team = res
    },
    getData () {
      const { domainsPath, $route } = this
      this.handleRequest({
        name: `${domainsPath}/teams`,
        action: 'getOne',
        data: {
          id: $route.params.id
        }
      }).then(this.setData)
    }
  },
  created () {
    this.getData()
  }
}
</script>
